import type { StateDetailSchool } from '../../types';

interface SchoolTooltipProps {
  position: { x: number; y: number };
  school: StateDetailSchool;
}

const STATUS_CONFIG = {
  blast: { label: 'In Blast', dotColor: 'bg-green-500', textColor: 'text-green-700 dark:text-green-300' },
  competitor: { label: 'Competitor', dotColor: 'bg-red-500', textColor: 'text-red-700 dark:text-red-300' },
  open: { label: 'Open', dotColor: 'bg-gray-400', textColor: 'text-gray-600 dark:text-gray-400' },
} as const;

export default function SchoolTooltip({ position, school }: SchoolTooltipProps) {
  const config = STATUS_CONFIG[school.status];
  const platformLabel = school.status === 'competitor' && school.competitorPlatform
    ? `: ${school.competitorPlatform.replace(/_/g, ' ')}`
    : '';

  return (
    <div
      className="absolute z-50 pointer-events-none"
      style={{ left: position.x + 12, top: position.y - 10 }}
    >
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg px-3 py-2 max-w-[220px]">
        <div className="font-medium text-sm text-gray-900 dark:text-gray-100 truncate">{school.name}</div>
        {school.city && (
          <div className="text-xs text-gray-500 dark:text-gray-400">{school.city}</div>
        )}
        <div className="flex items-center gap-1.5 mt-1">
          <span className={`h-2 w-2 rounded-full ${config.dotColor}`} />
          <span className={`text-xs font-medium ${config.textColor}`}>
            {config.label}{platformLabel}
          </span>
        </div>
        {school.repName && (
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            Rep: {school.repName}
          </div>
        )}
      </div>
    </div>
  );
}
